import $ from 'jquery';

const MobileMenu = (el) => {
    let $el = $(el);
    $el.click(function (e) {
        e.preventDefault();
        $('body').toggleClass('menu-active');
        $('html').toggleClass('no-scroll-mobile');
    });
};

export default MobileMenu;
